const firebaseProjectName = "profe-jobs";
const firebaseApiKey = "AIzaSyB5UVjUdv9r3_HaDIWIC2vHtPtXDXHXUwU";
const firebaseMessagingSenderId = "1009965999181";
const firebaseAppId = "1:1009965999181:web:e2b800226a1ec43c6f6804";
const firebaseMeasurementId = "G-WYZM9PPBP4";
const endpointDomainApi = "https://us-central1-profe-jobs-beta.cloudfunctions.net/";

export const environment = {
  country: "CL",
  production: false,
  beta: true,
  testing: false,
  basePath: 'https://profejobs.cl',
  basePathDomain: 'beta.profejobs.cl',
  basePathCanonical: 'https://www.profejobs.cl',
  domain_profe_class: 'https://profeclass-beta.web.app',
  basePathComplaintChannel: 'https://replace.canaldedenuncias.beta.profejobs.cl',
  relativePathComplaintChannel: 'canaldedenuncias.beta.profejobs.cl',
  endpoint:
  {
    domainApi: endpointDomainApi,
    apiuser: endpointDomainApi + "apiuserV3/",
    apicomplaint: endpointDomainApi + "complaintV3/",
    apijob: endpointDomainApi + "apijobV3/",
    apiemployee: endpointDomainApi + "apiemployeeV3/",
    apidocument: endpointDomainApi + "apidocumentV3/",
    apiadmin: endpointDomainApi + "apiadminV3/",
    apievaluar: endpointDomainApi + "evaluarV3/",
    apichat: endpointDomainApi + "apichatV3/",
    apiemployer: endpointDomainApi + "apiemployerV3/",
    apiconfig: endpointDomainApi + "apiconfigV3/",
    apipublic: endpointDomainApi + "apiV3/public/",
    apiregulation: endpointDomainApi + "regulationV3/",
    apicertificates: endpointDomainApi + "certificatesV3/",
    apireference: endpointDomainApi + "apireferenceV3/",
    apitwilio: endpointDomainApi + "apitwilioV3/",
  },
  firebase: {
    projectId: "profe-jobs-beta",
    appId: "1:500745936593:web:d162fb3ec8cecbb3026ff0",
    storageBucket: "profe-jobs-beta.appspot.com",
    apiKey: "AIzaSyDkfywVxeeUykAwsE0Z8CAB4gumgznbcJY",
    authDomain: "profe-jobs-beta.firebaseapp.com",
    messagingSenderId: "500745936593",
    measurementId: "G-GN25VPN3N6"
  },
  appVersion: require('../../package.json').version + '-beta'
};
